import { makeStyles } from '@material-ui/core/styles';




export default makeStyles((theme) => ({

  appBar: {
    borderRadius: 15,
    margin: '30px 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  heading: {
    color: 'rgba(0,183,255, 1)',
  },
  image: {
    marginLeft: '15px',
  },
  [theme.breakpoints.down('sm')]: {
    mainContainer: {
      flexDirection: "column-reverse"
    }
  },
  appContainer: {
    // backgroundImage: `url(${background})`,
    // backgroundSize: '100%',
    // backgroundRepeat: 'no-repeat',
    // backgroundAttachment: 'fixed',
    width: '100%',
    textAlign: 'center',
    // scrollBehavior: 'smooth',
  },
  backgroundImage: {
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: -100,
    width: '100vw',
  }
}));